
export default {
  name: 'BrandNotice',
  props: {
    brandNotice: {
      type: Object,
      required: true
    }
  }
};
